import React from "react";
import ConditionalTooltipWrapper from "../../../helpers/components/ConditionalTooltipWrapper";
import Typography from "../../../Typography";
import { BaseMetaLabel } from "./styled";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function MetaLabel(_ref) {
  var label = _ref.label,
    tooltipContent = _ref.tooltipContent;
  return /*#__PURE__*/_jsxs(BaseMetaLabel, {
    children: [/*#__PURE__*/_jsx("span", {
      children: "\xB7"
    }), /*#__PURE__*/_jsx(ConditionalTooltipWrapper, {
      tooltipContent: tooltipContent,
      children: /*#__PURE__*/_jsx(Typography, {
        variant: "caption",
        color: "lowContrast",
        children: label
      })
    })]
  });
}
export default MetaLabel;